export const countriesUemoa = [
  {
    code: "SN",
    label: "Sénégal",
    dial: "221",
    flag: "https://flagcdn.com/w40/sn.png",
    status: "ACTIVE",
  },
  {
    code: "CI",
    label: "Côte d’Ivoire",
    dial: "225",
    flag: "https://flagcdn.com/w40/ci.png",
    status: "ACTIVE",
  },
  {
    code: "ML",
    label: "Mali",
    dial: "223",
    flag: "https://flagcdn.com/w40/ml.png",
    status: "ACTIVE",
  },
  {
    code: "GN",
    label: "Guinée",
    dial: "224",
    flag: "https://flagcdn.com/w40/gn.png",
    status: "DISABLED",
  },
  {
    code: "BF",
    label: "Burkina Faso",
    dial: "226",
    flag: "https://flagcdn.com/w40/bf.png",
    status: "ACTIVE",
  },
  {
    code: "TG",
    label: "Togo",
    dial: "228",
    flag: "https://flagcdn.com/w40/tg.png",
    status: "ACTIVE",
  },
  {
    code: "BJ",
    label: "Bénin",
    dial: "229",
    flag: "https://flagcdn.com/w40/bj.png",
    status: "ACTIVE",
  },
  {
    code: "NE",
    label: "Niger",
    dial: "227",
    flag: "https://flagcdn.com/w40/ne.png",
    status: "DISABLED",
  },
  {
    code: "GW",
    label: "Guinée-Bissau",
    dial: "245",
    flag: "https://flagcdn.com/w40/gw.png",
    status: "DISABLED",
  },

  // Ajouts API
  {
    code: "NG",
    label: "Nigeria",
    dial: "234",
    flag: "https://flagcdn.com/w40/ng.png",
    status: "ACTIVE",
  },
  {
    code: "CD",
    label: "RDC",
    dial: "243",
    flag: "https://flagcdn.com/w40/cd.png",
    status: "DISABLED",
  },
  {
    code: "GH",
    label: "Ghana",
    dial: "233",
    flag: "https://flagcdn.com/w40/gh.png",
    status: "ACTIVE",
  },
  {
    code: "KE",
    label: "Kenya",
    dial: "254",
    flag: "https://flagcdn.com/w40/ke.png",
    status: "ACTIVE",
  },
  {
    code: "CM",
    label: "Cameroun",
    dial: "237",
    flag: "https://flagcdn.com/w40/cm.png",
    status: "ACTIVE",
  },
];